<template>
  <!-- The Process heading and intro text -->
  <div class="text-center">
    <div class="row">
      <div class="col">
        <h1>The Process</h1>
      </div>
    </div>
    <div class="row d-none d-md-block">
      <div class="col">
        <!-- "the process" slider for desktop -->
        <swiper
          :modules="modules"
          :direction="'vertical'"
          :slides-per-view="1"
          :pagination="{
            clickable: true,
          }"
          :autoplay="{
            delay: 4800,
            disableOnInteraction: false,
          }"
          :lazy="true"
          class="process-imgs"
        >
          <swiper-slide class="process-imgs"
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep1.jpg?v=1681247437" width="1200" height="400"
              style="height:auto;"
          /></swiper-slide>
          <swiper-slide class="process-imgs"
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep2.jpg?v=1681247433" width="1200" height="400"
              style="height:auto;"
          /></swiper-slide>
          <swiper-slide class="process-imgs"
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep3.jpg?v=1681247445" width="1200" height="400"
              style="height:auto;"
          /></swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- "the process" slider for mobile -->
    <div class="row d-block d-md-none">
      <div class="col">
        <swiper
          :modules="modules"
          :slides-per-view="1"
          :autoplay="{
            delay: 4800,
            disableOnInteraction: false,
          }"
          :lazy="true"
        >
          <swiper-slide
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep1-mobile.jpg?v=1681249502"
          /></swiper-slide>
          <swiper-slide
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep2-mobile.jpg?v=1681249499"
          /></swiper-slide>
          <swiper-slide
            ><img
              src="https://cdn.shopify.com/s/files/1/0281/7544/files/delDiaStep3-mobile.jpg?v=1681249502"
          /></swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script src="./ctrl-dd-process.js"></script>
